import type { JSX } from 'react';

import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import type { CarrierType } from '@/api/types/Jizda';

// Small caption under the carrier name (overview DOPRAVCE column + mobile
// card) distinguishing a VAPAS own-fleet jízda from an external contractor
// (zadání §5). The carrier-type *tab editor* in the detail is the downstream
// carrier-spz card — this is overview display only.
export const CarrierTypeCaption = ({
  carrierType,
}: {
  carrierType: CarrierType;
}): JSX.Element => {
  const theme = useTheme();
  const { t } = useTranslation('orders');
  return (
    <Typography
      component="span"
      sx={{
        fontSize: 11,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        fontWeight: 600,
        color:
          carrierType === 'VAPAS'
            ? theme.palette.primary.main
            : theme.palette.text.secondary,
      }}
      data-testid="carrier-type-caption"
    >
      {t(`carrierType.${carrierType}`)}
    </Typography>
  );
};
